import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "menu is-unselectable" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("p", { class: "menu-label" }, "Events", -1);
const _hoisted_3 = {
    key: 0,
    class: "menu-list"
};
const _hoisted_4 = ["onClick"];
import { loading_success } from "@/lib/helpers";
import { PublicStore } from "@/lib/store/public";
export default /*#__PURE__*/ _defineComponent({
    __name: 'EventMenu',
    setup(__props) {
        const store = PublicStore();
        return (_ctx, _cache) => {
            const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon");
            return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
                _hoisted_2,
                (_unref(loading_success)(_unref(store).events))
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).events, (event) => {
                            return (_openBlock(), _createElementBlock("li", {
                                key: event.id
                            }, [
                                _createElementVNode("a", {
                                    onClick: _withModifiers(($event) => (_unref(store).select_event(event.id)), ["left"]),
                                    class: _normalizeClass(_unref(store).is_selected(event.id) ? 'is-active' : '')
                                }, [
                                    (_unref(store).user !== null)
                                        ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                                            key: 0,
                                            icon: ['fas', event.active ? 'eye' : 'eye-slash']
                                        }, null, 8, ["icon"]))
                                        : _createCommentVNode("", true),
                                    _createTextVNode(" " + _toDisplayString(event.name), 1)
                                ], 10, _hoisted_4)
                            ]));
                        }), 128))
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
